var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5743_1532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16389 0 0 7.16389 0 16C0 22.5515 3.93981 28.1801 9.57994 30.6548C9.5348 29.5373 9.57191 28.1971 9.85831 26.9808C10.1658 25.6818 11.9172 18.2621 11.9172 18.2621C11.9172 18.2621 11.4061 17.2404 11.4061 15.7307C11.4061 13.3592 12.7804 11.5887 14.4918 11.5887C15.9463 11.5887 16.6485 12.6816 16.6485 13.9907C16.6485 15.4538 15.7156 17.6421 15.2356 19.669C14.8344 21.3663 16.0883 22.7506 17.761 22.7506C20.7925 22.7506 22.8344 18.8569 22.8344 14.2435C22.8344 10.7371 20.4725 8.11235 16.1765 8.11235C11.3229 8.11235 8.30194 11.7317 8.30194 15.7748C8.30194 17.1687 8.71273 18.1517 9.35523 18.9131C9.65116 19.2642 9.69229 19.4031 9.58495 19.8049C9.50871 20.0993 9.33417 20.808 9.25943 21.0889C9.1526 21.4942 8.82458 21.6406 8.45693 21.4902C6.22144 20.5773 5.18019 18.1297 5.18019 15.3776C5.18019 10.8324 9.01367 5.38232 16.6159 5.38232C22.7245 5.38232 26.7476 9.80263 26.7476 14.548C26.7476 20.8246 23.2582 25.5137 18.1141 25.5137C16.3867 25.5137 14.7621 24.5798 14.2054 23.5195C14.2054 23.5195 13.2765 27.206 13.0799 27.9177C12.7408 29.1516 12.0767 30.3845 11.4693 31.3455C12.9403 31.7799 14.4662 32.0003 16 32C24.8356 32 32 24.8361 32 16C32 7.16389 24.8361 0 16 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5743_1532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.bacecfaacdc78e9698c69e9ac5d24f83.svg";
export { ForwardRef as ReactComponent };